import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ɵcreateInjector as createInjector,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  SchoolNameSource,
  TabloTextConfig,
  TabloTextConfigOptions,
} from '@ui/tablo-generator/types';
import { TypedFormBuilder } from '@ui/form/TypedFormBuilder';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { filter, tap } from 'rxjs/operators';
import { ZalamoObject } from '@ui/orders/graphql';

@Component({
    selector: 'lib-tablo-text-editor',
    templateUrl: './tablo-text-editor.component.html',
    styleUrls: ['./tablo-text-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabloTextEditorComponent extends AliveState implements OnInit {
  @Output() updated = new EventEmitter<TabloTextConfigOptions>();
  @Input() publicSessionOrganizationId!: string;
  model = this.fb.typedGroup<Omit<TabloTextConfigOptions, 'text'>>({
    align: ['left'],
    fontSize: [50],
    font: ['Arial'],
    verticalAlign: ['top'],
    color: ['#000000'],
    addYearToGroupName: [false],
    beforeText: [''],
    afterText: [''],
    fontLatterSpacing: [1],
    pickedNameSource: [SchoolNameSource.Classic],
    uppercase: [false],
  });
  selfUpdate = false;
  isGroup = false;
  isSchoolName = false;
  nameSourceOptions = [
    {
      name: 'Klasyczna',
      value: SchoolNameSource.Classic,
    },
  ];
  @Input() set currentConfig(config: TabloTextConfig) {
    if (config.source === ZalamoObject.PublicSessionOrganizationGroup) {
      this.isGroup = true;
    }
    this.isSchoolName =
      config.source === ZalamoObject.PublicSessionOrganization;

    if (config.officialName) {
      this.nameSourceOptions.push({
        name: 'Oficjalna',
        value: SchoolNameSource.Official,
      });
    }
    if (config.shortName) {
      this.nameSourceOptions.push({
        name: 'Skrócona',
        value: SchoolNameSource.Short,
      });
    }
    this.selfUpdate = true;
    this.model.patchValue(config.config);
    this.selfUpdate = false;
  }
  constructor(private fb: TypedFormBuilder, private injector: Injector) {
    super();
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.model.valueChanges.pipe(
        filter(() => !this.selfUpdate),
        tap((value) => this.updated.emit(value)),
      ),
    );
  }
  async editSchoolName() {
    const { PublicSessionOrganizationsModule } = await import(
      '../../../../../../../photographer-panel/src/app/modules/public-session-organizations/public-session-organizations.module'
    );
    const injector = createInjector(
      PublicSessionOrganizationsModule,
      this.injector,
    );
    const carouselModule = injector.get(PublicSessionOrganizationsModule);
    await carouselModule.editSchoolSettings(this.publicSessionOrganizationId);
  }
}
